import { Appointment, AppointmentID } from "./Appointment";
import { CarNote } from "./CarNote";
import { Dealer, DealerID } from "./Dealer";
import { DealerLocation, DealerLocationID } from "./DealerLocation";
import { KeyloopMapping } from "./KeyloopMapping";
import { CarTyres, TruckTyres, VehicleTyre } from "./Tyre";

export type CarID = number;

export type CarTyresID = number;

export enum CAR_TYPE {
  Car = 0,
  Unknown = 1,
  Van = 2,
  Motorcycle = 3,
  Truck = 4,
  Bus = 5,
  LightTruck = 6
}

export interface Car {
  created_on: string;
  updated_on: string;
  id: CarID; // Claire Car ID
  is_truck: boolean; // True if its a truck
  make: string; // Car make
  model: string; // Car model
  fuel: string; // Fuel type
  reg_nr: string; // Registration plate
  reg_nr_escaped: string;
  vin_nr: string; // Vehicle identification number
  dms_nr: string; // Car ID in the DMS
  profile_picture?: string; // Car picture URL
  engine_number: string;
  ocw_enabled: boolean; // The car supports mobile app over the air connectivity
  fleet_number: string;
  vehicle_type: CAR_TYPE; // The vehicle's type
  dms_registration: string | null; // DMS registration date
  rdw_first_registration: string | null; // First registration date
  rdw_first_registration_nl: string | null; // First NL registration date
  rdw_type_goedkeurings_nummer: string; // RDW type goedkeurings nummer
  rdw_type: string; // RDW type
  rdw_variant: string; // RDW variant
  rdw_uitvoering: string; // RDW uitvoering
  apk_date_dms: string | null; // Dutch technical inspection DMS date
  hu_date_dms: string | null; // German technical inspection DMS date
  warranty_date_start: string | null; // When the factory warranty begins
  warranty_date_end: string | null; // When the factory warranty ends
  warranty_extended: string | null; // Typically an insurance warranty that goes beyond the factory warranty
  warranty_type: string; // Type of the factory warranty
  warranty_extended_type: string; // Type of the extra warranty
  rob_lease_expiration: string | null; // Expiration date of the lease contract with ROB
  has_dbb: boolean; // Indicates if the Car has a contract in DBB
  dbb_works_with_free_stock: boolean; // Indicates if the Car has a contract in DBB works with free stock
  dbb_appointment_date: string | null; // The Appointment date in DBB
  dbb_tyre_pickup_requested_at: string | null; // Tyre pickup for DBB was requested at
  alignment_recommended: boolean; // Is alignment recommended
  dealer_id: DealerID;
  dealer_location_id: DealerLocationID;
  dealer?: Dealer;
  dealer_location?: DealerLocation;
  on_car_tyres?: CarTyres; // Deprecated: CarTyres object for the tyres on the car, see that model for more details.
  in_storage_tyres?: CarTyres; // Deprecated: CarTyres object for the tyres in storage, see that model for more details.
  truck_tyres?: TruckTyres[]; // Deprecated: TruckTyres object for the tyres of truck
  car_lead_prediction?: CarLeadPrediction;
  notes?: CarNote[]; // Notes on the car created in claire
  tyres?: VehicleTyre[]; // Tyres that are associated with the vehicle
  keyloop_mappings?: KeyloopMapping[]; // Keyloop provider code mappings for the car
  dms_driver_id?: string; // used by dms v3 importer
  dms_owner_id?: string; // used by dms v3 importer
  dms_contractor_id?: string; // used by dms v3 importer
}

export interface CarLeadPrediction {
  created_on: string;
  updated_on: string;
  car_id: CarID;
  next_date?: string;
  predicted_date: string | null;
  is_leased: boolean;
  appointment_id: AppointmentID;
  dealer_location_id: DealerLocationID;
  car?: Car;
  appointment?: Appointment;
  dealer_location?: DealerLocation;
}
